export default [
    {
        "consumption_id": "brand-5d0e0dd4-3d5d-4d7f-89b3-a25c8415840f",
        "value": "Weedco"
    },
    {
        "consumption_id": "brand-0d7990f3-a6bd-47b7-b207-7c8cb28d9731",
        "value": "Caribbean Green"
    },
    {
        "consumption_id": "brand-b58b2006-c8f7-4d4b-9314-d1e5f19a2704",
        "value": "Nextgen"
    },
    {
        "consumption_id": "brand-dd6ca5fc-439f-4d46-afc2-d0188939c81d",
        "value": "Prich Biotech"
    },
    {
        "consumption_id": "brand-2db03d4b-6f16-4994-85a4-d938b4e8574a",
        "value": "Farma Verde"
    },
    {
        "consumption_id": "brand-20393741-2992-4445-83da-db7a5a264f7d",
        "value": "IMC"
    },
    {
        "consumption_id": "brand-ca42a50c-3e77-4616-9f11-a62558556354",
        "value": "Firstmedical Cannabis"
    },
    {
        "consumption_id": "brand-ca155af1-81fb-493b-bd43-b0b37c0d8505",
        "value": "Nueva Verde Luz"
    },
  
    {
        "consumption_id": "brand-bbc0ffe4-245e-491d-9dde-abb4c4e05f6b",
        "value": "Green Health"
    },
  
    {
        "consumption_id": "brand-69b38949-e087-497d-8ac1-16270d4ff456",
        "value": "Medgrow"
    },
  
    {
        "consumption_id": "brand-44e6b645-800d-4544-bb77-acbdcd2bb5b4",
        "value": "Cultive Culture"
    },
  
    {
        "consumption_id": "brand-ec400e55-2ceb-4469-9c84-b0283f161ee1",
        "value": "TPZ Ventures"
    },
  
    {
        "consumption_id": "brand-380dfc3c-858f-41fd-93ab-6a3064811154",
        "value": "Anani Medical Pharmaceutical"
    },
  
    {
        "consumption_id": "brand-78cf81ee-91fc-45bb-be52-c0ce5efda8cb",
        "value": "Advanced Logistics"
    },
  
    {
        "consumption_id": "brand-61326af7-756b-4450-8d86-a65907e436bb",
        "value": "Boriken"
    },
  
    {
        "consumption_id": "brand-ea87b277-bd6e-4f74-9069-4be8f9b92809",
        "value": "Biocann Cannabis"
    },
  
    {
        "consumption_id": "brand-572fafa7-6262-486a-856f-6aed08436ca8",
        "value": "Caramor"
    },
  
    {
        "consumption_id": "brand-84b2d2b1-ac80-4bcc-9f63-17686bda9a50",
        "value": "Caribbean Green Growers"
    },
  
    {
        "consumption_id": "brand-9dda91fb-c5f6-4f3c-b2e1-d9c69888753c",
        "value": "Encanto Giving Tree"
    },
  
    {
        "consumption_id": "brand-d6446a10-fa3f-4f00-94e2-09d4bd52b191",
        "value": "Greenlander"
    },
  
    {
        "consumption_id": "brand-81bf2efc-76b3-4489-bebf-a3ad57637b04",
        "value": "Carribean Medical Center Cannabis"
    },
  
    {
        "consumption_id": "brand-e509b556-685d-42a8-9759-2869bf76131b",
        "value": "Med Seed"
    },
  
    {
        "consumption_id": "brand-c682f50a-411b-4567-a4d0-2a82f76466fc",
        "value": "Borincana The Health Center"
    },
  
    {
        "consumption_id": "brand-b0f200d6-9ca5-4b7a-bb1f-b559d1fbf5a8",
        "value": "Organic Med Growers"
    },
    {
        "consumption_id": "brand-5c438bb6-a5e3-433f-a9ab-6158ebc39eda",
        "value": "IMC Corp"
    },
    {
        "consumption_id": "brand-aab8cfbb-920b-4f7d-bf5c-d2c06084a827",
        "value": "Kindcure"
    },
    {
        "consumption_id": "brand-a38287e8-4f6a-40c9-bfd1-c7f64c0c677f",
        "value": "Consolidated"
    },
    {
        "consumption_id": "brand-c671b00b-ff9f-4a66-9daa-d4d292940bab",
        "value": "Alternative Health Solutions"
    },
    {
        "consumption_id": "brand-167b87ee-d012-45e9-8290-6ce0f0cc4a55",
        "value": "PR Henderson"
    },
    {
        "consumption_id": "brand-cd216455-b011-484c-8a11-70d067707b5c",
        "value": "Better Science"
    },
    {
        "consumption_id": "brand-06d65491-453a-4301-8cce-6d500f8896ff",
        "value": "Columbia Care Puerto Rico"
    },
    {
        "consumption_id": "brand-3793ff30-005f-4871-86b5-11eb3794bf81",
        "value": "MC AGRO"
    },
    {
        "consumption_id": "brand-bbe97e87-30d2-4568-9f38-97e1362988fe",
        "value": "Best Buds"
    },
    {
        "consumption_id": "brand-9c6d6b85-77e2-4487-9295-f09a67facfeb",
        "value": "Biogrow"
    },
    {
        "consumption_id": "brand-d9734fcf-b3d0-4bb8-abb3-e471262df3e3",
        "value": "Healthweed"
    },
    {
        "consumption_id": "brand-8d9673a1-20f6-4309-9368-74a8109466df",
        "value": "Alternative Therapy"
    },
    {
        "consumption_id": "brand-f549a0db-fe18-46a6-8efe-d2fdf03b2a9d",
        "value": "Herbal Biotech"
    },
    {
        "consumption_id": "brand-ac5f3f85-a269-4c94-bb91-6f8b2fb3fdc7",
        "value": "Dulce Sueno"
    },
]